<template>
  <v-layout column>
    <vbt-search
      v-model="searchData"
      :items="searchFieldsConfig"
      @reset="onResetSearch"
      @search="onSearch"
    />

    <vbt-content-box
      :loading="isLoading"
      :loading-error="loadingError"
      :no-content="noContent"
      :go-back-btn="goBack"
      title="Information"
    >
      <vbt-table
        :items="packageReturns"
        :headers="headers"
        show-details-action
        @click:details="goToPackageReturn"
      >
        <template #createDate="{ item: { createDate: _date } }">
          {{ formatDate(_date) }}
        </template>

        <template #expireDate="{ item: { expireDate: _date } }">
          {{ formatDate(_date) }}
        </template>

        <template #productReshipable="{ item: { productReshipable: _state } }">
          <kernel-package-return-state :state="_state" />
        </template>

        <template #resendToCustomer="{ item: { resendToCustomer: _state } }">
          <kernel-package-return-state :state="_state" />
        </template>
      </vbt-table>

      <vbt-pagination
        v-model="pageNum"
        :items-count="pagedItemsCount"
      />
    </vbt-content-box>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useDataLoading, usePagination, useSearch } from '@mixins/factories';

import { formatDate } from '@helpers';

import { namespace as LocationsNamespaces } from '@store/modules/locations.types';

import {
  namespace as PackageReturnsNamespace,
  ActionTypes as PackageReturnsActionTypes,
} from '../store.types';

import KernelPackageReturnState from '../_components/KernelPackageReturnState.vue';

const dataLoadingOptions = {
  getterName: PackageReturnsActionTypes.GET_PACKAGE_RETURNS,
  contentName: 'packageReturns',
  searchable: false,
};

const paginationOptions = {
  contentName: 'packageReturns',
};

const searchOptions = {
  initialSearchDataStates: [
    'trackingNumber', 'productReshipable', 'resendToCustomer',
  ],
  customTypes: {
    productReshipable: 'booleanString',
    resendToCustomer: 'booleanString',
  },
};

const headers = Object.freeze([
  { text: 'Tracking Number', value: 'trackingNumber' },
  { text: 'Create Date', value: 'createDate' },
  { text: 'Expire Date', value: 'expireDate' },
  { text: 'Product Reshipable', value: 'productReshipable' },
  { text: 'Resend To Customer', value: 'resendToCustomer' },
  { text: 'Reason', value: 'reason' },
  { text: 'Description', value: 'description' },
]);

export default {
  name: 'KernelPackageReturns',

  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
    useSearch(searchOptions),
  ],

  components: {
    KernelPackageReturnState,
  },

  data() {
    return {
      headers,
    };
  },

  computed: {
    ...mapState(LocationsNamespaces, ['suffix']),

    ...mapState(PackageReturnsNamespace, ['packageReturns']),

    searchFieldsConfig() {
      return [
        {
          value: 'productReshipable',
          label: 'Product Reshipable',
          type: 'toggle',
          flex: 'sm2',
        },
        {
          value: 'resendToCustomer',
          label: 'Resend To Customer',
          type: 'toggle',
          flex: 'sm2',
        },
        {
          value: 'trackingNumber',
          label: 'Tracking Number',
          type: 'text',
          flex: 'sm3',
        },
      ];
    },
  },

  methods: {
    ...mapActions(PackageReturnsNamespace, [PackageReturnsActionTypes.GET_PACKAGE_RETURNS]),

    goToPackageReturn({ id }) {
      this.$router.push({
        name: 'packageReturn',
        params: { id },
        query: { suffix: this.suffix },
      });
    },

    formatDate,
  },
};
</script>
